<template>
  <base-spinner v-if="loading" />
  <div v-else>
    <div>
      <div class="row align-items-center mb-2">
        <div class="col-6">
          <h5 class="result">{{ total }} {{ $t("results") }}</h5>
        </div>
        <div class="col-6 d-flex align-items-center justify-content-between flex-wrap">
          <div class="d-flex align-items-center justify-content-between flex-wrap"></div>
          <div class="d-flex justify-content-end mb-2 mb-lg-0 flex-wrap">
            <div class="mb-2">
              <base-button id="tax_types_filter_btn" variant="secondary" cus_style="padding:12px 16px"
                class="me-2 filter__btn" v-b-toggle.sidebar-backdrop @mouseenter="filterBtnHovered = true"
                @mouseleave="filterBtnHovered = false">
                <img :src="filterBtnHovered
                  ? require(`@/assets/images/icons/funnel-simple-bold-svgrepo-com.png`)
                  : require(`@/assets/images/icons/funnel-simple-bold-svgrepo-com.png`)
                  " alt="filter" />
              </base-button>
            </div>

            <!-- Filter LIst -->
            <div class="custom-filter filter-list">
              <b-sidebar id="sidebar-backdrop" :backdrop-variant="variant" bg-variant="white" backdrop
                :right="!isLangRtl" shadow>
                <div class="px-3 py-2">
                  <div>
                    <h4 class="custom-filter__head pt-2">
                      {{ $t("filter-by") }}
                    </h4>
                    <validation-observer ref="observer">
                      <form @submit.prevent="handleForm">
                        <h5 class="filter-input-title pt-2">
                          {{ $t("general") }}
                        </h5>
                        <hr />

                        <base-input type="text" label="trip-id" name="tripId" placeholder="trip-id" id="tripId"
                          field="tripId" :value="searchPayload.tripId" @change-value="setValue" :small="true">
                        </base-input>

                        <base-input type="text" label="client-id" id="client-id" name="clientId" placeholder="client-id"
                          field="clientId" :small="true" :value="searchPayload.clientId" @change-value="setValue">
                        </base-input>

                        <base-select
                          name="Status"
                          label="status"
                          :options="statusList"
                          :small="true"
                          field="status"
                          :value="searchPayload.status"
                          @change-value="getStatus"
                        >
                        </base-select>

                        <base-select
                          name="Branch"
                          label="branch"
                          :options="$store.getters['enums/branch_enums']"
                          :small="true"
                          field="operatingBranch"
                          :value="searchPayload.operatingBranch"
                          @change-value="getBranch"
                        >
                        </base-select>

                        <div>
                          <div class="row">
                            <h5 class="filter-input-title">{{ $t("driverBehavior") }}</h5>
                            <div class="col-6">
                              <div class="input-group">
                                <base-input type="text"  placeholder="min" field="driverBehaviourMin" :small="true"
                                  :value="searchPayload.driverBehaviourMin" @change-value="setValue">
                                </base-input>
                              </div>
                            </div>
                            <div class="col-6">
                              <div class="input-group">
                                <base-input type="text"  placeholder="max" field="driverBehaviourMax" :small="true"
                                  :value="searchPayload.driverBehaviourMax" @change-value="setValue">
                                </base-input>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <h5 class="filter-input-title">{{ $t("needsMet") }}</h5>
                            <div class="col-6">
                              <base-input type="text"  placeholder="min":small="true"  field="needsMetMin" :value="searchPayload.needsMetMin"
                                @change-value="setValue" />
                            </div>
                            <div class="col-6">
                              <base-input type="text"  placeholder="max" :small="true" field="needsMetMax" :value="searchPayload.needsMetMax"
                                @change-value="setValue" />
                            </div>
                          </div>

                          <div class="row">
                            <h5 class="filter-input-title">
                              {{ $t("recommendation") }}
                            </h5>
                            <div class="col-6">
                              <base-input type="text"  id="recommendationMin" 
                                placeholder="min" field="recommendationMin" :small="true"
                                :value="searchPayload.recommendationMin" @change-value="setValue">
                              </base-input>

                            </div>
                            <div class="col-6">
                              <base-input type="text"  id="recommendationMax" 
                                placeholder="max" field="recommendationMax" :small="true"
                                :value="searchPayload.recommendationMax" @change-value="setValue">
                              </base-input>
                            </div>
                          </div>
                          <div class="row">
                            <h5 class="filter-input-title">
                              {{ $t("scheduleAccuracy") }}
                            </h5>
                            <div class="col-6">
                              <div class="input-group">
                                <base-input type="text"  id="scheduleAccuracyMin" 
                                  placeholder="min" field="scheduleAccuracyMin" :small="true"
                                  :value="searchPayload.scheduleAccuracyMin" @change-value="setValue">
                                </base-input>
                              </div>
                            </div>
                            <div class="col-6">
                              <div class="input-group">
                                <base-input type="text"  id="scheduleAccuracyMax" 
                                  placeholder="max" field="scheduleAccuracyMax" :small="true"
                                  :value="searchPayload.scheduleAccuracyMax" @change-value="setValue">
                                </base-input>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <h5 class="filter-input-title">
                              {{ $t("vehicleCleanliness") }}
                            </h5>
                            <div class="col-6">
                              <div class="input-group">
                                <base-input type="text"  id="vehicleCleanlinessMin" 
                                  placeholder="min" field="vehicleCleanlinessMin" :small="true"
                                  :value="searchPayload.vehicleCleanlinessMin" @change-value="setValue">
                                </base-input>
                              </div>
                            </div>
                            <div class="col-6">
                              <div class="input-group">
                                <base-input type="text"  id="vehicleCleanlinessMax"
                                  placeholder="max" field="vehicleCleanlinessMax" :small="true"
                                  :value="searchPayload.vehicleCleanlinessMax" @change-value="setValue">
                                </base-input>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div class="row mb-2">
                            <h5 class="filter-input-title pt-2 mt-3 mb-2">
                              {{ $t("date-range") }}
                            </h5>
                            <div class="col-6">
                              <div class="form-label label-text">
                                {{ $t("from") }}
                              </div>
                              <validation-provider :rules="searchPayload.toDate ? '' : ''" name="Transaction Date From"
                                v-slot="{ errors }">
                                <div class="input-group">
                                  <b-modal :id="modalTransactionDateFrom" ref="modalTransactionDateFrom" centered
                                    hide-header hide-footer no-fade static content-class="w-auto mx-auto">
                                    <b-calendar v-model="searchPayload.fromDate" @context="
                                      (ctx) => (ContextTransactionDateFrom = ctx)
                                    " @input="$refs.modalTransactionDateFrom.hide()">
                                    </b-calendar>
                                  </b-modal>
                                  <b-input-group v-b-modal="modalTransactionDateFrom">
                                    <label
                                      class="form-control input-time-group d-flex flex-row justify-content-between align-items-center cursor-pointer">
                                      <span v-if="!ContextTransactionDateFrom.selectedYMD" class="time-placeHolder">{{
                                        $t("select-date") }}</span>
                                      {{ ContextTransactionDateFrom.selectedYMD }}
                                      <img :src="require(`@/assets/images/icons/select-time.svg`)
                                        " alt="select time" />
                                    </label>
                                  </b-input-group>
                                </div>
                                <div class="form-label error-text">
                                  <span>{{ errors[0] }}</span>
                                </div>
                              </validation-provider>
                            </div>
                            <div class="col-6">
                              <div class="form-label label-text">
                                {{ $t("to") }}
                              </div>
                              <validation-provider :rules="{
                                oldest_date: {
                                  dates: [
                                    searchPayload.fromDate || '1970-01-01',
                                    searchPayload.toDate,
                                  ],
                                },
                              }" name="Transaction Date To" v-slot="{ errors }">
                                <div class="input-group">
                                  <b-modal :id="modalTransactionDateTo" ref="modalTransactionDateTo" centered
                                    hide-header hide-footer no-fade static content-class="w-auto mx-auto">
                                    <b-calendar v-model="searchPayload.toDate" @context="
                                      (ctx) => (ContextTransactionDateTo = ctx)
                                    " @input="$refs.modalTransactionDateTo.hide()">
                                    </b-calendar>
                                  </b-modal>
                                  <b-input-group v-b-modal="modalTransactionDateTo">
                                    <label
                                      class="form-control input-time-group d-flex flex-row justify-content-between align-items-center cursor-pointer">
                                      <span v-if="!ContextTransactionDateTo.selectedYMD" class="time-placeHolder">{{
                                        $t("select-date") }}</span>
                                      {{ ContextTransactionDateTo.selectedYMD }}
                                      <img :src="require(`@/assets/images/icons/select-time.svg`)
                                        " alt="select time" />
                                    </label>
                                  </b-input-group>
                                </div>
                                <div class="form-label error-text">
                                  <span>{{ errors[0] }}</span>
                                </div>
                              </validation-provider>
                            </div>
                          </div>
                        </div>

                        <base-button class="search-btn primary mt-4 mb-3" :disabled="loading" type="submit"
                          id="receipt-voucher-submit-btn">
                          {{ $t("search") }}
                        </base-button>
                        <base-button id="receipt-voucher-reset-btn" class="reset-btn mb-1" @click="resetSearchPayload">
                          {{ $t("reset-filters") }}
                        </base-button>
                      </form>
                    </validation-observer>
                  </div>
                </div>
              </b-sidebar>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div>
      <div>
        <b-alert :show="error && error.length ? true : false" variant="danger">
          <div v-html="error || '&nbsp;'"></div>
        </b-alert>
        <div class="col-12">
          <b-table :items="items" :fields="fields" :hover="true" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
            :per-page="perPage" :current-page="1" label-sort-asc="" label-sort-desc="" label-sort-clear=""
            sort-icon-right show-empty :no-border-collapse="true" responsive="lg"
            thead-class="table-thead text-center bg-transparent " tbody-class="table-tbody text-center cursor-pointer"
            ref="selectableTable" info="true" class="new-theme-custom-table"
            @row-clicked="(feedback) => showFeedbackDetails(feedback)">
            <template #empty> {{ $t("empty-row") }} </template>
            <template #cell(linked_account)="{ item }">
              <div class="d-flex justify-content-between pe-2 align-items-center">
                <div>
                  {{ item.linked_account }}
                </div>
                <b-dropdown variant="transparent">
                  <div class="d-flex flex-column justify-content-center delete-edit-model">
                    <div id="tax_types_edit" class="d-flex justify-content-center delete-edit-model-text"
                      @mouseenter="editHovered = true" @mouseleave="editHovered = false"
                      @click.stop="moveToEdit(item.id)">
                      <img :src="editHovered
                        ? require('@/assets/images/icons/pincle-edit.svg')
                        : require('@/assets/images/icons/pincle-edit.svg')
                        " alt="edit" width="13" />
                      <p class="text-center my-2 mx-3">{{ $t("details") }}</p>
                    </div>
                  </div>
                </b-dropdown>
              </div>
            </template>
          </b-table>
          <b-pagination v-if="total" v-model="currentPage" :total-rows="total" :per-page="perPage" first-number
            last-number aria-controls="my-table" class="d-flex justify-content-end"></b-pagination>
        </div>
      </div>
    </div>
    <b-sidebar :visible="isDetailsShown" id="transaction-detail-sidebar-backdrop" bg-variant="white" backdrop
      :right="!isLangRtl" shadow width="70%" @hidden="hideFeedbackDetails">
      <FeedbackDetails v-if="selectedFeedback" :feedbackData="selectedFeedback" />
    </b-sidebar>
  </div>
</template>

<script>
import TripRatingService from "@/services/trip-rating.service";
import moment from "moment";
import FeedbackDetails from "./FeedbackDetails.vue";

export default {
  components: {
    FeedbackDetails,
  },
  data() {
    return {
      loading: false,
      error: null,
      editHovered: false,
      filterBtnHovered: false,
      sortBy: "",
      sortDesc: false,
      perPage: 10,
      currentPage: 1,
      total: 0,
      modalTransactionDateFrom: "date-picker-transactionDateFrom",
      modalTransactionDateTo: "date-picker-transactionDateTo",
      ContextTransactionDateFrom: {},
      ContextTransactionDateTo: {},
      statusList: [{ value: "PENDING", text: "Pending" }, { value: "REVIEWED", text: "Reviewed" }],
      fields: [
        {
          key: "trip._id",
          label: this.$t("trip"),
          sortable: true,
          class: "px-2 align-middle",
          thStyle: {
            backgroundPosition: "right 0.5rem center !important",
          },
        },
        {
          key: "tripDate",
          label: this.$t("trip-date"),
          sortable: true,
          class: "px-2 align-middle",
          thStyle: {
            backgroundPosition: "right 0.5rem center !important",
          },
        },
        {
          key: "client.id",
          label: this.$t("client-id"),
          sortable: true,
        },
        {
          key: "client.name",
          label: this.$t("client-name-english"),
          sortable: false,
        },
        {
          key: "client.arabicName",
          label: this.$t("client-name-arabic"),
          sortable: false,
        },
        {
          key: "client.contactPerson[0].name",
          label: this.$t("contact-person-english"),
          sortable: false,
        },
        {
          key: "client.contactPerson[0].arabicName",
          label: this.$t("contact-person-arabic"),
          sortable: false,
        },
        {
          key: "updated_on",
          label: this.$t("submission-date"),
          sortable: false,
        },
        {
          key: "status",
          label: this.$t("status"),
          sortable: false,
        },
      ],
      variant: "transparent",
      items: [],
      selectedFeedback: null,
      isDetailsShown: null,
      searchPayload: {
        tripId: null,
        clientId: null,
        status: null,
        operatingBranch: null,
        driverBehaviourMin: null,
        driverBehaviourMax: null,
        needsMetMin: null,
        needsMetMax: null,
        recommendationMin: null,
        recommendationMax: null,
        scheduleAccuracyMin: null,
        scheduleAccuracyMax: null,
        vehicleCleanlinessMin: null,
        vehicleCleanlinessMax: null,
        fromDate: null,
        toDate: null
      },
    };
  },
  computed: {
  },
  methods: {
    setValue(val, field) {
      this.searchPayload[field] = val;
    },
    getBranch(branch) {
      this.searchPayload.operatingBranch = branch;
    },
    getStatus(status) {
      this.searchPayload.status = status;
    },
    formatDate(date) {
      return moment(date).locale("en").format("DD-MM-YYYY");
    },
    showFeedbackDetails(feedback) {
      this.isDetailsShown = true;
      TripRatingService.get(feedback.id).then((data) => {
        this.selectedFeedback = data;
      });
    },
    hideFeedbackDetails() {
      this.isDetailsShown = false;
      this.selectedFeedback = null;
    },
    async handleForm() {
      const valid = await this.$refs.observer.validate();
      if (!valid) return;
      this.getData();
    },
    getData() {
      this.loading = true;
      this.error = null;
      this.total = 0;
      this.items = [];

      let params = new URLSearchParams();
      params.append("page", this.currentPage || 1);
      params.append("limit", this.perPage);
      params.append("sort", "-updated_on");

      if (this.searchPayload.tripId) params.append("tripId", this.searchPayload.tripId);
      if (this.searchPayload.clientId) params.append("clientId", this.searchPayload.clientId);
      if (this.searchPayload.status) params.append("status", this.searchPayload.status);
      if (this.searchPayload.operatingBranch) params.append("operatingBranch", this.searchPayload.operatingBranch );
      if (this.searchPayload.driverBehaviourMin) params.append("feedbackRatings.driverBehavior", "gte:" + this.searchPayload.driverBehaviourMin);
      if (this.searchPayload.driverBehaviourMax) params.append("feedbackRatings.driverBehavior", "lte:" + this.searchPayload.driverBehaviourMax);
      if (this.searchPayload.vehicleCleanlinessMin) params.append("feedbackRatings.vehicleCleanliness", "gte:" + this.searchPayload.vehicleCleanlinessMin);
      if (this.searchPayload.vehicleCleanlinessMax) params.append("feedbackRatings.vehicleCleanliness", "lte:" + this.searchPayload.vehicleCleanlinessMax);
      if (this.searchPayload.recommendationMin) params.append("feedbackRatings.recommendation", "gte:" + this.searchPayload.recommendationMin);
      if (this.searchPayload.recommendationMax) params.append("feedbackRatings.recommendation", "lte:" + this.searchPayload.recommendationMax);
      if (this.searchPayload.scheduleAccuracyMin) params.append("feedbackRatings.scheduleAccuracy", "gte:" + this.searchPayload.scheduleAccuracyMin);
      if (this.searchPayload.scheduleAccuracyMax) params.append("feedbackRatings.scheduleAccuracy", "lte:" + this.searchPayload.scheduleAccuracyMax);
      if (this.searchPayload.needsMetMin) params.append("feedbackRatings.needsMet", "gte:" + this.searchPayload.needsMetMin);
      if (this.searchPayload.needsMetMax) params.append("feedbackRatings.needsMet", "lte:" + this.searchPayload.needsMetMax);

      if (this.searchPayload.fromDate) {
        params.append(
          "updated_on",
          "gte:" + this.searchPayload.fromDate + "T00:00:00.000Z"
        );
      }

      if (this.searchPayload.toDate) {
        params.append(
          "updated_on",
          "lte:" + this.searchPayload.toDate + "T23:59:59.000Z"
        );
      }
      params.append(
        "select",
        "_id, client.name,client.arabicName,client.id,feedbackRatings,trip,operatingBranch,trip.scheduledStartDate,trip.scheduledEndDate,client.contactPerson,feedbackComments,updated_on,operatingBranch.name,status"
      );

      TripRatingService.search(params)
        .then(({ items, total }) => {
          this.items = items;
          this.total = total;
          this.loading = false;

          this.items = items?.map((each) => {
            return {
              id: each._id,
              status: each?.status,
              feedbackRatings: each?.feedbackRatings,
              client: each?.client,
              trip: each?.trip,
              tripDate: this.formatDate(each?.trip.scheduledEndDate),
              feedbackComments: each.feedbackComments,
              updated_on: this.formatDate(each?.updated_on),
              status: each?.status
            };
          });
        })
        .catch(({ message }) => {
          this.error = message;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetSearchPayload() {
      this.searchPayload.tripId = null;
      this.searchPayload.clientId = null;
      this.searchPayload.fromDate = null;
      this.searchPayload.toDate = null;
      this.searchPayload.operatingBranch = null;
      this.searchPayload.recommendationMin = null;
      this.searchPayload.recommendationMax = null;
      this.searchPayload.vehicleCleanlinessMin = null;
      this.searchPayload.vehicleCleanlinessMax = null;
      this.searchPayload.needsMetMin = null;
      this.searchPayload.needsMetMax = null;
      this.searchPayload.driverBehaviourMin = null;
      this.searchPayload.driverBehaviourMax = null;
      this.searchPayload.scheduleAccuracyMin = null;
      this.searchPayload.scheduleAccuracyMax = null;
      this.getData();
    },
  },
  watch: {
    currentPage(val) {
      if (val) this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  created() {
    this.$store.dispatch("enums/GET_BRANCH_ENUMS");
  },
};
</script>
